import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import ActionForm from "components/actions/ActionForm";
import { createAction } from "graphql/mutations";

const ActionCreateForm = ({ onSuccess }) => {
  const navigate = useNavigate();
  const action = {
    name: "",
    description: "",
    shortName: "",
    valueType: "",
    values: [],
    errorMsg: "",
    successMsg: "",
    icon: "",
    iconColor: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        description,
        shortName,
        valueType,
        values,
        errorMsg,
        successMsg,
        icon,
        iconColor,
      } = valuesParam;

      await API.graphql({
        query: createAction.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            description,
            shortName,
            valueType,
            values: JSON.stringify(values),
            errorMsg,
            successMsg,
            icon,
            iconColor,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/actions");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <ActionForm onSubmit={onSubmit} initialValues={action} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Acción",
    successAdded: "Acción agregada con éxito",
    responses: {},
  },
});

export default ActionCreateForm;
